import React from 'react';
import './App.css';
import CommonPage from './components/pages/CommonPage';
import {StepRoutes, CommonRoutes} from './components/pages/Routes';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import About from './components/pages/About';
import Landing from './components/pages/Landing';
import StepsComponent from './components/steps/StepsComponent';
import { ConfigProvider } from 'antd';
import type { ThemeConfig } from 'antd/es/config-provider/context';

const neutralTheme: ThemeConfig = {
  token: {
    colorPrimary: '#262626', // gray-9
    colorInfo: '#262626',
    colorBgBase: '#ffffff',
    colorBgContainer: '#f5f5f5',
    colorBgLayout: '#f5f5f5',
    colorTextBase: '#262626',
    colorLink: '#595959',
    controlHeight: 38,
  },
  components: {
    Layout: {
      headerBg: '#595959',
      bodyBg: '#f5f5f5',
    },
    Menu: {
      itemBg: '#595959',
      itemColor: '#f5f5f5',
      itemHoverColor: '#ffffff',
      itemSelectedColor: '#ffffff',
      itemSelectedBg: '#434343',
    },
    Button: {
      defaultColor: '#262626',
      defaultBg: '#f5f5f5',
      defaultBorderColor: '#d9d9d9',
      defaultHoverBg: '#f0f0f0',
      defaultHoverBorderColor: '#bfbfbf',
      defaultActiveBg: '#d9d9d9',
      defaultActiveBorderColor: '#8c8c8c',
    },
  },
};


function App() {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const appShellClassName = isLanding ? 'app-shell app-shell--landing' : 'app-shell';

  return (
      <ConfigProvider theme={neutralTheme}>
        <div className={appShellClassName}>
          <Routes>
            <Route element={<CommonRoutes />}>
              <Route path="/" element={<CommonPage />}>
                <Route index element={<Landing />} />
                <Route path="about" element={<About />} />
              </Route>
            </Route>
            <Route element={<StepRoutes />}>
              <Route path="/steps" element={<CommonPage />} >
                <Route index element={<Navigate to="1" replace />} />
                <Route path=":stepId" element={<StepsComponent />} />
              </Route>
            </Route>
          </Routes>
        </div>
      </ConfigProvider>
  );
}

export default App;